import { render, staticRenderFns } from "./AccountDetail.vue?vue&type=template&id=1b036388&scoped=true&"
import script from "./AccountDetail.vue?vue&type=script&lang=js&"
export * from "./AccountDetail.vue?vue&type=script&lang=js&"
import style0 from "./AccountDetail.vue?vue&type=style&index=0&id=1b036388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b036388",
  null
  
)

export default component.exports